import { gql } from "@apollo/client/core";

export const getManyGroupsByUserID = gql`
  query GetManyGroupsByUserID(
    $userId: String!
    $filter: GetManyGroupsByUserIDRequestFilterInput
    $paginationArguments: PaginationArgumentsInput
  ) {
    GetManyGroupsByUserID(input: { filter: $filter, paginationArguments: $paginationArguments, userId: $userId }) {
      connection {
        edges {
          node {
            alias
            createdAt
            description
            logoAssetUrl
            name
            groupId
            updatedAt
            organizationId
            roleByUser {
              title
            }
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
`;
